define('boxes/helpers/address-finder',['jquery', 'module', 'boxes/helpers/tooltip'], function ($, module, tooltip) {
	'use strict';
	var configuration = module.config(),
		countryCodes, ENTER_EVENT = 13;

	function init(signUpDetail) {
		countryCodes = configuration.addressFinderCountryCodes.split(',');
		changeAddressFinderOnCountrySelected(signUpDetail);
		eventListeners(signUpDetail);
		autoCompleteAddress(signUpDetail);
	}

	function eventListeners(signUpDetail) {
		signUpDetail.$box.find('#addressBtn').click(function (event) {
			addressHandler(signUpDetail, event);
		});
		signUpDetail.$box.find('input[name=PARAM_POST_CODE]').keypress(function (event) {
			if (event.which === ENTER_EVENT) {
				$(this).next().focus();
				addressHandler(signUpDetail, event);
			}
		});
	}

	function addressHandler(signUpDetail, event) {
		event.stopPropagation();
		var $signupDetailBox = signUpDetail.$box;
		var $postCode = $signupDetailBox.find('#dynamicAddress').find('input[name=PARAM_POST_CODE]');
		var postCode = $postCode.val();

		if (postCode === '' || isPostCodeNotValid($postCode)) {
			hideResults(signUpDetail);
			return;
		}
		var selectedCountryCode = $signupDetailBox.find('#countries-holder option:selected').data('country-code');
		$.get('/pp?flow=AddressFinder&countryCode=' + selectedCountryCode + '&postCode=' + postCode).done(function (data) {
			if (data.addresses.length < 1) {
				handlePostCodeNotFound(signUpDetail, $postCode);
				return;
			}
			var htmlMethod = {method: 'html'}, $addressHolder = signUpDetail.$box.find('#address-holder');
			$.Mustache.addFromDom('address-template');
			$addressHolder.mustache('address-template', {addresses: data.addresses}, htmlMethod);
			signUpDetail.$box.find('#dynamicAddress').find('.find-address').show();
			autoCompleteAddress(signUpDetail);
		});
	}

	function showCorrectAddressLayout(signUpDetail) {
		var $signupDetailBox = signUpDetail.$box;
		var $staticAddress = $signupDetailBox.find('#staticAddress');
		var $dynamicAddress = $signupDetailBox.find('#dynamicAddress');
		var selectedCountryCode = $signupDetailBox.find('#countries-holder option:selected').data('country-code');

		if (isAddressFinderEnabled(selectedCountryCode)) {
			$staticAddress.hide();
			$dynamicAddress.show();
			disableStaticAddress(signUpDetail.$box);
			enableDynamicAddress(signUpDetail.$box);
		} else {
			$dynamicAddress.hide();
			$staticAddress.show();
			disableDynamicAddress(signUpDetail.$box);
			enableStaticAddress(signUpDetail.$box);
		}
	}

	function autoCompleteAddress(signUpDetail) {
		signUpDetail.$box.find('#address-holder li').off('click').on('click', function () {
			var addressValue = $(this).data('number') + ', ' + $(this).data('street');
			signUpDetail.$box.find('#dynamicAddress input[name=PARAM_ADDRESS1]').val(addressValue);
			signUpDetail.$box.find('#dynamicAddress input[name=PARAM_CITY]').val($(this).data('posttown'));
			signUpDetail.$box.find('.find-address').hide();
		});
	}

	function isAddressFinderEnabled(selectedCountryCode) {
		return $.inArray(selectedCountryCode, countryCodes) > -1;
	}

	function handlePostCodeNotFound(signUpDetail, $postCode) {
		hideResults(signUpDetail);
		tooltip.showPopover($postCode.parent(), $postCode.parent().data('post-code-not-found'));
		clearDynamicAddressFields(signUpDetail);
	}

	function hideAddressResultsOnFocusOut(signUpDetail) {
		$(document).off('click').click(function () {
			if (areResultsVisible(signUpDetail)) {
				hideResults(signUpDetail);
			}
		});
	}

	function hideResults(signUpDetail) {
		signUpDetail.$box.find('#dynamicAddress .find-address').hide();
	}

	function isPostCodeNotValid($postCode) {
		return $postCode.parent().hasClass('has-error');
	}

	function areResultsVisible(signUpDetail) {
		return signUpDetail.$box.find('.find-address').css('display') !== 'none';
	}

	function changeAddressFinderOnCountrySelected(signUpDetail) {
		signUpDetail.$box.find('#countries-holder').change(function () {
			showCorrectAddressLayout(signUpDetail);
		});
	}

	function disableStaticAddress($signupBox) {
		$signupBox.find('#staticAddress input[name=PARAM_ADDRESS1]').attr('disabled', 'disabled').addClass('ignore');
		$signupBox.find('#staticAddress input[name=PARAM_CITY]').attr('disabled', 'disabled').addClass('ignore');
		$signupBox.find('#staticAddress input[name=PARAM_POST_CODE]').attr('disabled', 'disabled').addClass('ignore');
	}


	function enableStaticAddress($signupBox) {
		$signupBox.find('#staticAddress input[name=PARAM_ADDRESS1]').removeAttr('disabled').removeClass('ignore');
		$signupBox.find('#staticAddress input[name=PARAM_CITY]').removeAttr('disabled').removeClass('ignore');
		$signupBox.find('#staticAddress input[name=PARAM_POST_CODE]').removeAttr('disabled').removeClass('ignore');
	}

	function disableDynamicAddress($signupBox) {
		$signupBox.find('#dynamicAddress input[name=PARAM_ADDRESS1]').attr('disabled', 'disabled').addClass('ignore');
		$signupBox.find('#dynamicAddress input[name=PARAM_CITY]').attr('disabled', 'disabled').addClass('ignore');
		$signupBox.find('#dynamicAddress input[name=PARAM_POST_CODE]').attr('disabled', 'disabled').addClass('ignore');
	}

	function enableDynamicAddress($signupBox) {
		$signupBox.find('#dynamicAddress input[name=PARAM_ADDRESS1]').removeAttr('disabled').removeClass('ignore');
		$signupBox.find('#dynamicAddress input[name=PARAM_CITY]').removeAttr('disabled').removeClass('ignore');
		$signupBox.find('#dynamicAddress input[name=PARAM_POST_CODE]').removeAttr('disabled').removeClass('ignore');
	}

	function clearDynamicAddressFields(signUpDetail) {
		signUpDetail.$box.find('#dynamicAddress input[name=PARAM_ADDRESS1]').val('');
		signUpDetail.$box.find('#dynamicAddress input[name=PARAM_CITY]').val('');
		signUpDetail.$box.find('#dynamicAddress input[name=PARAM_POST_CODE]').val('');
	}

	function clearStaticAddressFields(signUpDetail) {
		signUpDetail.$box.find('#staticAddress input[name=PARAM_ADDRESS1]').val('');
		signUpDetail.$box.find('#staticAddress input[name=PARAM_CITY]').val('');
		signUpDetail.$box.find('#staticAddress input[name=PARAM_POST_CODE]').val('');
	}

	var addressFinder = {};
	addressFinder.init = init;
	addressFinder.hideAddressResultsOnFocusOut = hideAddressResultsOnFocusOut;
	addressFinder.showCorrectAddressLayout = showCorrectAddressLayout;
	return addressFinder;
});

